import { getInstance } from '../index';
import { getApiEmbedUwAssets, apiBaseUrl } from '../../utilities/api/apiHelper';

class UnderWriting {
  constructor() {
    this.axios = getInstance();
  }

  async getEnquiryById(applicantId) {
    return await this.axios.get(
      `${apiBaseUrl}/underwriting/${applicantId}${getApiEmbedUwAssets()}`
    );
  }

  async getLookUpQuestionOption(data) {
    const { branch, tag, answer, stem } = data;
    return await this.axios.get(
      `${apiBaseUrl}/underwriting/lookupQuestionOption/${branch}/${tag}/${answer}?stem=${encodeURIComponent(
        stem
      )}`
    );
  }

  async postEnquiryById(applicantId, answers, isQi) {
    const url = isQi ? 'underwriting/' : 'actions/provideanswers/';
    return await this.axios.post(
      `${apiBaseUrl}/${url}${applicantId}${getApiEmbedUwAssets()}`,
      { answers }
    );
  }

  async postCloseEnquiry(applicantId) {
    return await this.axios.post(
      `${apiBaseUrl}/underwriting/${applicantId}/close${getApiEmbedUwAssets()}`
    );
  }

  async fetchApplicantUnderwritingEnquiryByApplicantId({ applicantId }) {
    return await this.axios.get(
      `${apiBaseUrl}/underwriting/${applicantId}${getApiEmbedUwAssets()}`,
      {}
    );
  }

  async postAcceptPreUnderwritingDeclarationById(applicationId, applicantId) {
    return await this.axios.post(
      `${apiBaseUrl}/application/${applicationId}/applicant/${applicantId}/acceptPreUnderwritingDeclaration`,
      {}
    );
  }

  async postAcceptPostUnderwritingDeclarationById(applicationId, applicantId) {
    return await this.axios.post(`${apiBaseUrl}/actions/acceptuwdeclaration`, {
      applicationId,
      applicantId,
    });
  }

  async postUnderwritingStartPreSale(applicantId, agentId) {
    return await this.axios.post(
      `${apiBaseUrl}/underwriting/${applicantId}/start${getApiEmbedUwAssets()}`,
      {
        answers: {
          ENQUIRY_TYPE: 'Pre-sale',
          AGENT_ID: agentId,
        },
      }
    );
  }
}

const underwriting = new UnderWriting(getInstance());
export default underwriting;
